import { writable, get } from 'svelte/store'

export type PromptType = 'posting' | 'system'

export interface UnifiedPromptState {
  isVisible: boolean
  currentType: PromptType
}

function createUnifiedPromptStore() {
  const { subscribe, set, update } = writable<UnifiedPromptState>({
    isVisible: false,
    currentType: 'posting' // 기본값은 포스팅 프롬프트
  })

  return {
    subscribe,
    
    show(type?: PromptType) {
      update(state => ({
        ...state,
        isVisible: true,
        currentType: type || state.currentType
      }))
    },
    
    hide() {
      update(state => ({
        ...state,
        isVisible: false
      }))
    },
    
    toggle() {
      update(state => ({
        ...state,
        isVisible: !state.isVisible
      }))
    },
    
    setType(type: PromptType) {
      update(state => ({
        ...state,
        currentType: type
      }))
    },
    
    getState(): UnifiedPromptState {
      return get({ subscribe })
    }
  }
}

export const unifiedPromptStore = createUnifiedPromptStore()